(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('PlanejamentoController', PlanejamentoController);

    PlanejamentoController.$inject = ['$scope', 'Principal', '$state', 'Chamado', 'Sprint', 'Modulo', 'Sistema', 'Cliente', 'SolicitacaoDesenvolvimento'];

    function PlanejamentoController($scope, Principal, $state, Chamado, Sprint, Modulo, Sistema, Cliente, SolicitacaoDesenvolvimento) {
        var vm = this;
        vm.load = load;
        vm.alocar = alocar;
        vm.desalocar = desalocar;
        vm.alocarTarefa = alocarTarefa;
        vm.desalocarTarefa = desalocarTarefa;
        vm.podeAlocarTarefa = podeAlocarTarefa;
        vm.usuarioTemCliente = usuarioTemCliente;
        vm.getTarefasSprintPorModulo = getTarefasSprintPorModulo;
        vm.getHorasPormodulo = getHorasPormodulo;
        vm.getTempoEpico = getTempoEpico;
        vm.getCorPorTipo = getCorPorTipo;
        vm.carregarSistema = carregarSistema;
        vm.atualizarTarefa = atualizarTarefa;
        vm.selecionarSistema = selecionarSistema;
        vm.agruparChamados = agruparChamados;
        vm.chamadosPorModulo = {};
        vm.epicosSemTarefaAbertos = false;
        vm.toggleEpicosSemTarefa = toggleEpicosSemTarefa;
        vm.getTarefasParaAlocar = getTarefasParaAlocar;
        vm.getEpicosSemTarefa = getEpicosSemTarefa;
        vm.getQtdTarefasParaAlocar = getQtdTarefasParaAlocar;

        function carregarModulos() {
            Modulo.getBySistema({id: vm.sistema.id}, function (data) {
                vm.modulos = data;
                vm.modulo = data[0];
                agruparChamados();
            });
        }

        function selecionarSistema(sistema) {
            vm.sistema = sistema;
            carregarClientes();
        }

        function atualizarTarefa(tarefa) {
            SolicitacaoDesenvolvimento.update(tarefa, agruparChamados);
        }

        function load() {
            Principal.identity().then(function (account) {
                vm.account = account;
                carregarSistema();
            });

        }

        function tempoEstimado(tarefa) {
            return Number(tarefa && tarefa.tempoEstimado) || 0;
        }

        function somaTempoTarefas(tarefas) {
            var total = 0;
            angular.forEach(tarefas || [], function (tarefa) {
                total += tempoEstimado(tarefa);
            });
            return total;
        }

        function bucketModuloVazio(modulo) {
            return {
                modulo: modulo,
                epicos: [],
                tarefasParaAlocar: [],
                epicosSemTarefa: [],
                tempoDisponivel: 0
            };
        }

        function derivarListasDoModulo(moduloId) {
            var bucket = vm.chamadosPorModulo[moduloId];
            if (!bucket) {
                return;
            }
            var tarefasParaAlocar = [];
            var epicosSemTarefa = [];
            angular.forEach(bucket.epicos, function (epico) {
                if (!epico.tarefas || epico.tarefas.length === 0) {
                    epicosSemTarefa.push(epico);
                    return;
                }
                angular.forEach(epico.tarefas, function (tarefa) {
                    tarefasParaAlocar.push({
                        tarefa: tarefa,
                        epico: epico
                    });
                });
            });
            bucket.tarefasParaAlocar = tarefasParaAlocar;
            bucket.epicosSemTarefa = epicosSemTarefa;
        }

        function adicionarEpicoPraPlanejar(epico) {
            var chamado = epico.chamado;
            if (!vm.chamadosPorModulo[chamado.modulo.id]) {
                vm.chamadosPorModulo[chamado.modulo.id] = bucketModuloVazio(chamado.modulo);
            }
            vm.chamadosPorModulo[chamado.modulo.id].epicos.push(epico);

            if (!epico.dependentes || epico.dependentes.length === 0) {
                var horasTarefas = somaTempoTarefas(epico.tarefas);
                vm.chamadosPorModulo[chamado.modulo.id].tempoDisponivel =
                    vm.chamadosPorModulo[chamado.modulo.id].tempoDisponivel + horasTarefas;

                if (vm.horasDisponiveisCliente[chamado.cliente.id]) {
                    vm.horasDisponiveisCliente[chamado.cliente.id].horasSemDependencia =
                        vm.horasDisponiveisCliente[chamado.cliente.id].horasSemDependencia + horasTarefas;
                }
            }
            derivarListasDoModulo(chamado.modulo.id);
        }

        function toggleEpicosSemTarefa() {
            vm.epicosSemTarefaAbertos = !vm.epicosSemTarefaAbertos;
        }

        function getTarefasParaAlocar(modulo) {
            if (!modulo || !vm.chamadosPorModulo[modulo.id]) {
                return [];
            }
            return vm.chamadosPorModulo[modulo.id].tarefasParaAlocar || [];
        }

        function getEpicosSemTarefa(modulo) {
            if (!modulo || !vm.chamadosPorModulo[modulo.id]) {
                return [];
            }
            return vm.chamadosPorModulo[modulo.id].epicosSemTarefa || [];
        }

        function getQtdTarefasParaAlocar(modulo) {
            return getTarefasParaAlocar(modulo).length;
        }

        function carregarClientes() {
            Cliente.getBySistema({sistemaId: vm.sistema.id}, function (data) {
                vm.clientes = [];
                for (var j = 0; j < data.length; j++) {
                    var c = data[j];
                    if (c.ativo !== true) {
                        continue;
                    }
                    vm.clientes.push(c);
                }
                vm.horasDisponiveisCliente = {};
                for (var i = 0; i < vm.clientes.length; i++) {
                    vm.clientes[i].selecionado = true;
                    vm.horasDisponiveisCliente[vm.clientes[i].id] = {
                        cliente: vm.clientes[i],
                        horasOcupadas: 0,
                        horasSemDependencia: 0,
                        horasDisponiveis: vm.clientes[i].horasDisponiveis
                    };
                }
                carregarModulos();
            });
        }

        function agruparChamados() {

            Sprint.getBySituacao({situacao: 'ABERTA'}, function (aberta) {
                vm.chamadosPorModulo = {};

                for (var i = 0; i < aberta.clientes.length; i++) {

                    var cliente = aberta.clientes[i];

                    if (vm.horasDisponiveisCliente[cliente.cliente.id]) {
                        vm.horasDisponiveisCliente[cliente.cliente.id].horasDisponiveis = cliente.horasDisponiveis;
                        vm.horasDisponiveisCliente[cliente.cliente.id].horasOcupadas = 0;
                        vm.horasDisponiveisCliente[cliente.cliente.id].horasSemDependencia = 0;
                    }

                    if (vm.horasDisponiveisCliente[cliente.cliente.id] && vm.horasDisponiveisCliente[cliente.cliente.id].cliente.selecionado) {
                        Chamado.getProximasSprints({
                            idSistema: vm.sistema.id,
                            idCLiente: cliente.cliente.id
                        }, function (epicos) {

                            angular.forEach(epicos, function (epico) {
                                if (!epico.tarefas) {
                                    epico.tarefas = [];
                                }
                                if (!vm.chamadosPorModulo[epico.chamado.modulo.id]) {
                                    vm.chamadosPorModulo[epico.chamado.modulo.id] =
                                        bucketModuloVazio(epico.chamado.modulo);
                                }

                                Chamado.getDependentes({id: epico.chamado.id}, function (data) {
                                    epico.dependentes = data;
                                    epico.chamado.dependentes = data;
                                    adicionarEpicoPraPlanejar(epico);
                                }, function () {
                                    epico.dependentes = [];
                                    epico.chamado.dependentes = [];
                                    adicionarEpicoPraPlanejar(epico);
                                });

                            });
                        });
                    }
                }

                SolicitacaoDesenvolvimento.queryBySprintSistema({
                    sprintId: aberta.id,
                    sistemaId: vm.sistema.id
                }, function (tarefas) {
                    aberta.tarefas = tarefas;
                    vm.sprintAberta = aberta;

                    angular.forEach(vm.sprintAberta.tarefas, function (tarefa) {
                        var clienteId = tarefa.cliente && tarefa.cliente.id;
                        if (!clienteId && tarefa.chamado && tarefa.chamado.cliente) {
                            clienteId = tarefa.chamado.cliente.id;
                        }
                        if (clienteId && vm.horasDisponiveisCliente[clienteId]) {
                            vm.horasDisponiveisCliente[clienteId].horasOcupadas =
                                vm.horasDisponiveisCliente[clienteId].horasOcupadas + tempoEstimado(tarefa);
                        }
                    });
                });
            })
        }

        load();

        function carregarSistema() {
            Sistema.getByUser({}, function (data) {
                vm.sistemas = data;
                selecionarSistema(vm.sistemas[0]);
            })
        }

        function alocar(chamado) {
            // legado: alocação passou a ser por tarefa
        }

        function desalocar(chamado) {
            // legado: desalocação passou a ser por tarefa
        }

        function alocarTarefa(tarefa, epico) {
            SolicitacaoDesenvolvimento.alocarPlanejamento(tarefa, agruparChamados);
        }

        function desalocarTarefa(tarefa) {
            SolicitacaoDesenvolvimento.desalocarPlanejamento(tarefa, agruparChamados);
        }

        /**
         * Não hard-bloqueia só por existir dependente na lista.
         * getDependentes já omite bloqueadores FECHADO; a regra completa
         * (tarefas pendentes do bloqueador) é validada no backend.
         */
        function podeAlocarTarefa(epico) {
            return !!vm.sprintAberta;
        }

        function usuarioTemCliente(cliente) {
            for (var i = 0; i < vm.account.clientes.length; i++) {
                var obj = vm.account.clientes[i];
                if (obj.id === cliente.id) {
                    return true;
                }
            }

            return false;
        }

        function getTarefasSprintPorModulo(modulo) {
            if (!vm.sprintAberta || !vm.sprintAberta.tarefas) {
                return [];
            }
            return vm.sprintAberta.tarefas.filter(function (tarefa) {
                return tarefa.modulo && tarefa.modulo.id === modulo.id &&
                    tarefa.sistema && tarefa.sistema.id === vm.sistema.id;
            });
        }

        function getHorasPormodulo(modulo) {
            var tempo = 0;
            if (modulo.id != null) {
                var tarefas = getTarefasSprintPorModulo(modulo);
                for (var i = 0; i < tarefas.length; i++) {
                    tempo += tempoEstimado(tarefas[i]);
                }
            }

            return tempo;
        }

        function getTempoEpico(epico) {
            return somaTempoTarefas(epico && epico.tarefas);
        }

        function getCorPorTipo(tipo) {
            switch (tipo) {
                case 'SUPORTE':
                    return 'warning';
                case 'BUG':
                    return 'danger';
                case 'MELHORIA':
                    return 'info';
                case 'NOVA_FUNCIONALIDADE':
                    return 'success';
                default:
                    return 'info';
            }
        }
    }

})
();
